import { render, staticRenderFns } from "./AuctionChat.vue?vue&type=template&id=038dc5ea&scoped=true"
import script from "./AuctionChat.vue?vue&type=script&lang=js"
export * from "./AuctionChat.vue?vue&type=script&lang=js"
import style0 from "./AuctionChat.vue?vue&type=style&index=0&id=038dc5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038dc5ea",
  null
  
)

export default component.exports